export default __webpack_public_path__ + "02467b70a682d17259e0d40443f30491.png";